import {
  APP_INIT_RECEIVE, APP_REMOVE_ALERT,
  APP_SET_MAIN_CONTENT_FULL_HEIGHT,
  APP_USER_LOAD_BALANCE_SUCCESS,
} from 'moduleBase/constants';
import { GlobalState } from 'moduleBase/types/State';
import ActionWithPayload from 'moduleBase/reducers/types/ActionWithPayload';
import { UserLoadBalanceResponseType } from 'moduleBase/actions/types/UserLoadBalanceResponseType';
import { RemoveAlertPayloadType } from 'moduleBase/actions/types/RemoveAlertPayloadType';

const reducerGlobal = (state: GlobalState = {
  isInit: false,
}, action: ActionWithPayload): GlobalState => {
  switch (action.type) {
    case APP_INIT_RECEIVE:
    case APP_SET_MAIN_CONTENT_FULL_HEIGHT:
      return { ...state, ...action.payload };
    case APP_USER_LOAD_BALANCE_SUCCESS: {
      const payload = action.payload as UserLoadBalanceResponseType;
      return {
        ...state,
        userMenu: {
          ...state.userMenu,
          wait: payload.wait,
          frozen: payload.frozen,
        },
      };
    }
    case APP_REMOVE_ALERT: {
      const payload = action.payload as RemoveAlertPayloadType;
      return {
        ...state,
        alerts: state.alerts.filter((alert) => alert.key !== payload.key),
      };
    }
    default:
      return state;
  }
};

export default reducerGlobal;
